'use strict';

var React = require('react');

var SvgFraudProtectMajor = function SvgFraudProtectMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.131.233c-2.37 1.383-5.37 2.33-7.634 2.646-.822.115-1.495.79-1.494 1.62l.002.497c-.03 6.043.477 11.332 9.462 14.903a1.45 1.45 0 0 0 1.062 0c8.991-3.571 9.503-8.859 9.471-14.903v-.501c0-.828-.673-1.51-1.491-1.638-2.149-.337-5.282-1.274-7.65-2.628a1.733 1.733 0 0 0-1.729.004zm4.577 8.478a1 1 0 0 0-1.414-1.415l-3.293 3.294-1.293-1.293a1 1 0 1 0-1.414 1.414l2 2.001a1 1 0 0 0 1.414 0l4-4.001z"
  }));
};

exports.SvgFraudProtectMajor = SvgFraudProtectMajor;
